module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"@root":{"hooks.onStopInit":[{"value":function () {
var visitor = fox.getEnv('visitor');
this.setOption('visitor' + visitor.ucfirst(), 1);
this.registerOptions('#home', {
template: 'layout_home_freereg'
});
this.embedWidget('joinFormStep1', 'DomForm', {
elements: {
'login.type': fox.FormElementBase,
'email.type': fox.FormElementBase
}
});
},"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107015},"path":"@root","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// ./options/root.js
// module id = 1009
// module chunks = 4